export const confirmationModalStyle = {
  maxWidth: '600px',
  width: '100%',
};

export const fieldStyle = {
  paddingTop: '20px',
  width: '100%',
};

export const progressRingStyle = {
  display: 'flex',
  justifyContent: 'center',
  paddingTop: '20px',
};
